import { Content } from '../../types';

export const kepContent: Content = {
  title: 'קפ– עיירת חוף קסומה בדרום המדינה',
  imageUrl: 'https://tinyurl.com/kep-wide',
  introduction: `קפ הינה עיירת חוף קטנה וקסומה השוכנת במחוז בעל שם זהה בדרום קמבודיה, בסמוך לגבול עם וייטנאם. העיר ממוקמת כ-25 ק"מ מדרום-מזרח לקמפוט ונחשבת ליעד אידיאלי למטיילים המחפשים שלווה, טבע וחוויות קולינריות אותנטיות. ניתן להגיע אליה באמצעי תחבורה שונים, כולל אופנועים, טוקטוקים, ואף רכיבה על אופניים מקמפוט, חוויה המאפשרת הצצה לכפרים המסורתיים ולחיי היומיום של המקומיים.`,
  sections: [
    {
      title: 'אווירה, היסטוריה ומורשת קולוניאלית',
      content: `קפ ידועה באווירה הרגועה שלה, חופיה הציוריים והאוכל הטרי שמגיע היישר מן הים. היא נחשבת לאחת מפניני הדרום של קמבודיה ומשלבת בין נופים טרופיים מרהיבים, היסטוריה מרתקת ומטבח ייחודי. בתקופה הקולוניאלית הצרפתית, העיר שימשה כעיירת נופש יוקרתית לאליטה המקומית והאירופית. עד היום ניתן לראות ברחבי העיר וילות נטושות מימי הזוהר שלה, עדות לתקופה בה שימשה כמרכז בילוי ופנאי יוקרתי. במהלך שלטון החמר רוז', רבים מבתי הקיט נהרסו או ננטשו והם נותרו כחלק מהנוף העירוני המשלב ישן וחדש.`,
      type: 'text',
    },
    {
      title: 'אטרקציות מרכזיות בקפ',
      content: [
        {
          subtitle: 'חופי הים השלווים',
          text: 'חופי קפ מציעים רוגע ושלווה, כאשר בסופי שבוע הם מתמלאים במבקרים מקומיים ואילו באמצע השבוע הם כמעט נטושים, מה שמאפשר חוויית חוף אינטימית ונעימה.',
        },
        {
          subtitle: 'שוק הסרטנים (Kep Crab Market)',
          text: 'שוק הסרטנים הוא אחת מהאטרקציות המרכזיות של העיר ומציע דגה טרייה, לרבות הסרטנים המפורסמים של קפ. המבקרים יכולים לצפות בדייגים המקומיים מושכים את שללם מהים ולטעום ממאכלים אותנטיים. המנה הפופולרית ביותר היא סרטנים טריים ברוטב פלפל ירוק מקמפוט, הנחשב לאחד המאכלים האיקוניים של האזור.',
        },
        {
          subtitle: 'הפארק הלאומי קפ',
          text: 'הפארק מציע מסלולי הליכה ואופניים מרהיבים בתוך יערות טרופיים. אחד המסלולים הבולטים הוא "The Sunset Rock Trail", מסלול באורך של כ-8 ק"מ המוביל לנקודת תצפית עוצרת נשימה על הים בשעת השקיעה.',
        },
        {
          subtitle: 'אי הארנב (Koh Tonsay)',
          text: 'אי קטן ואותנטי, הנמצא כ-5 ק"מ מחופי קפ ומציע חופים יפים ואווירה של פעם. האי מאוכלס בכמות קטנה של תושבים המתפרנסים בעיקר מדיג ומתיירות. המבקרים מגיעים לרוב לטיולי יום, אך ניתן גם להישאר ללון בבונגלוס פשוטים על החוף.',
        },
        {
          subtitle: 'תצפיות שקיעה',
          text: 'אחד הרגעים הקסומים ביותר בקפ הוא ללא ספק השקיעה. מומלץ לעלות לנקודת התצפית בפארק הלאומי או לשבת באחת מהמסעדות המקומיות לאורך החוף וליהנות מהנוף, תוך צפייה בתושבים המקומיים המגיעים לבלות במקום עם משפחותיהם.',
        },
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `קפ הינה יעד מושלם לאלו המחפשים לברוח מהמולת הערים הגדולות וליהנות מהשקט, הטבע והקולינריה המקומית. עם היסטוריה עשירה, חופים קסומים ואוכל מהים, טרי ביותר, היא מציעה חוויה בלתי נשכחת בדרום קמבודיה.`,
      type: 'text',
    },
  ],
};
